import { loaderAction, setMasterScheduleFormAction, setMasterCopyScheduleDaysAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { GetScheduleThunk } from "./GetScheduleThunk";
import { MASTER_COPY_SCHEDULE_DAYS_INITIAL } from "../initialStateConstant";

export const CopyScheduleThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment, master_schedule_form } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('master_id', master_schedule_form.master_id);
        formData.append('establishment', currentEstablishment);
        formData.append('copy_day', args.copy_day);
        formData.append('days', args.days);

        const response = await api({ data: formData, link: 'copy_schedule' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем данные в расписании
            dispatch(GetScheduleThunk({
                master_id: master_schedule_form.master_id,
                date: args.copy_day
            }));

            // Удаляем данные копирования
            dispatch(setMasterCopyScheduleDaysAction(MASTER_COPY_SCHEDULE_DAYS_INITIAL));

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};